module.exports = { langs: ["en"], defaultLangKey: "en" };
